var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmployerIco4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 40,
    viewBox: "0 0 39 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2331_12547)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.7227 7.95605C26.7227 7.77559 26.575 7.62793 26.3945 7.62793H10.6445C10.4641 7.62793 10.3164 7.77559 10.3164 7.95605V9.9248C10.3164 10.1053 10.4641 10.2529 10.6445 10.2529H26.3945C26.575 10.2529 26.7227 10.1053 26.7227 9.9248V7.95605ZM26.3945 13.5342H10.6445C10.4641 13.5342 10.3164 13.6818 10.3164 13.8623V15.8311C10.3164 16.0115 10.4641 16.1592 10.6445 16.1592H26.3945C26.575 16.1592 26.7227 16.0115 26.7227 15.8311V13.8623C26.7227 13.6818 26.575 13.5342 26.3945 13.5342ZM18.1914 19.4404H10.6445C10.4641 19.4404 10.3164 19.5881 10.3164 19.7686V21.7373C10.3164 21.9178 10.4641 22.0654 10.6445 22.0654H18.1914C18.3719 22.0654 18.5195 21.9178 18.5195 21.7373V19.7686C18.5195 19.5881 18.3719 19.4404 18.1914 19.4404ZM16.2227 32.0732H7.03516V7.19824C7.03516 4.9891 8.82602 3.19824 11.0352 3.19824H26.0039C28.213 3.19824 30.0039 4.9891 30.0039 7.19824V17.3076C30.0039 17.4881 30.1516 17.6357 30.332 17.6357H32.6289C32.8094 17.6357 32.957 17.4881 32.957 17.3076V6.24512C32.957 2.93141 30.2707 0.245117 26.957 0.245117H10.082C6.76832 0.245117 4.08203 2.93141 4.08203 6.24512V33.7139C4.08203 34.4398 4.66855 35.0264 5.39453 35.0264H16.2227C16.4031 35.0264 16.5508 34.8787 16.5508 34.6982V32.4014C16.5508 32.2209 16.4031 32.0732 16.2227 32.0732ZM30.857 29.0217C32.0465 27.943 32.793 26.3844 32.793 24.6494C32.793 21.3887 30.1475 18.7432 26.8867 18.7432C23.626 18.7432 20.9805 21.3887 20.9805 24.6494C20.9805 26.3844 21.727 27.943 22.9164 29.0217C20.5785 30.3547 18.9707 32.8238 18.8477 35.6703C18.8395 35.8549 18.9912 36.0107 19.1758 36.0107H21.1486C21.3209 36.0107 21.4645 35.8754 21.4768 35.699C21.6367 32.8607 24.0033 30.5967 26.8867 30.5967C29.7701 30.5967 32.1367 32.8607 32.2967 35.699C32.3049 35.8713 32.4484 36.0107 32.6248 36.0107H34.5977C34.7863 36.0107 34.934 35.8549 34.9258 35.6703C34.8068 32.8197 33.1949 30.3547 30.857 29.0217ZM26.8867 21.3682C28.6996 21.3682 30.168 22.8365 30.168 24.6494C30.168 26.4623 28.6996 27.9307 26.8867 27.9307C25.0738 27.9307 23.6055 26.4623 23.6055 24.6494C23.6055 22.8365 25.0738 21.3682 26.8867 21.3682Z",
    fill: "#17B67C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2331_12547",
    x: 0.0820312,
    y: 0.245117,
    width: 38.8438,
    height: 43.7656,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2331_12547"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2331_12547",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmployerIco4);
export default __webpack_public_path__ + "static/media/employer_ico_4.96e01df120fe0bf3e9776fc01e9f21a7.svg";
export { ForwardRef as ReactComponent };